import {Chart, _adapters} from "chart.js/auto";
import "chartjs-adapter-moment"

window.Chart = Chart;
